import axios from 'axios';
import { calculateKenoRound, gameHeaders, KENO_API } from '../keno/fairnessApi';
import { resolvers, tables, roundGame } from './calculation';

const same = (a, b) => JSON.stringify(a) === JSON.stringify(b);
export const verifyRecordedOutcome = async (fields, result, round, game) => {
  if (!round.server_seed_hash || result.hash !== round.server_seed_hash.toLowerCase()) throw new Error('The server seed does not match this bet’s committed hash.');
  const type = roundGame(round);
  if (type === 'blackjack') {
    if (!round.drawn?.length || !same(result.cards.slice(0, round.drawn.length), round.drawn)) throw new Error('The dealt-card sequence does not match this bet.');
    return 'Committed hash and dealt cards match.';
  }
  let calculated;
  if (type === 'keno') {
    const config = game.gameType === 'keno' && game.config ? game.config : (await axios.get(`${KENO_API}/keno/config`, { headers: gameHeaders(game.demo) })).data;
    calculated = await calculateKenoRound({ ...fields, nonce: Number(fields.nonce), picks: round.picks, risk: round.risk, betMinor: round.bet_minor, paytableVersion: round.paytable_version || 'gv-rounded-v1' }, config);
    if (!same(calculated.outcome.drawn, round.drawn) || calculated.outcome.matches !== round.matches) throw new Error('The Keno draw does not match this bet.');
  } else {
    calculated = resolvers[type](result.uints, round.params, tables[type], { betMinor: round.bet_minor });
    if (!Object.entries(calculated.outcome).every(([key, value]) => same(value, round.outcome[key]))) throw new Error('The calculated outcome does not match this bet.');
  }
  if (calculated.payoutMinor !== round.payout_minor || calculated.multiplierE8 / 1e8 !== round.multiplier) throw new Error('The calculated payout does not match this bet.');
  return 'Committed hash, outcome and payout match.';
};